export default function (value) {
  if (value) {
    return value.replace(/\n/gi, '<br>')
  }
}
